// extracted by mini-css-extract-plugin
export var container = "_4c-0";
export var disabled = "_4c-4";
export var fullWidth = "_4c-3";
export var lined = "_4c-1";
export var selected = "_4c-5";
export var tab = "_4c-2";